import React, { useState } from "react";

// Visual room picker: a button that opens a color-coded room grid for the
// chosen dates. Green = available, amber = booked, red = occupied, gray = out
// of order. Rooms carry {id, name, room_type_name, available, conflict}.
const CMETA = {
  available: { bg: "#E7F6EC", bd: "#1D7A44", fg: "#1D7A44" },
  booked: { bg: "#FAEEDA", bd: "#8A5A0B", fg: "#8A5A0B" },
  occupied: { bg: "#FCEBEB", bd: "#A32D2D", fg: "#A32D2D" },
  out_of_order: { bg: "#EFEFF2", bd: "#8a94a3", fg: "#5b6472" },
};
const keyFor = (r) => (r.conflict === "out_of_order" ? "out_of_order"
  : r.conflict === "occupied" ? "occupied"
  : r.conflict === "booked" ? "booked" : "available");
const avKey = (k) => "av_" + (k === "out_of_order" ? "ooo" : k);

export default function RoomPicker({ rooms, value, onChange, t, placeholder }) {
  const [open, setOpen] = useState(false);
  const list = rooms || [];
  const sel = list.find((r) => String(r.id) === String(value));
  return (
    <>
      <button type="button" onClick={() => setOpen(true)}
        style={{ padding: 8, borderRadius: 8, border: "1px solid #d8dee2", background: "#fff", cursor: "pointer", textAlign: "left", width: "100%", boxSizing: "border-box" }}>
        {sel ? sel.name + (sel.room_type_name ? ` (${sel.room_type_name})` : "") : (placeholder || t("pick_room"))}
      </button>
      {open && (
        <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, background: "rgba(6,20,26,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 18, maxWidth: 560, width: "100%", maxHeight: "80vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <b>{t("pick_room")}</b>
              <button type="button" onClick={() => setOpen(false)} style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#5b6472", lineHeight: 1 }}>×</button>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 12, fontSize: 12, color: "#5b6472" }}>
              {["available", "booked", "occupied", "out_of_order"].map((k) => (
                <span key={k} style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
                  <span style={{ width: 11, height: 11, borderRadius: 3, background: CMETA[k].bd }} />{t(avKey(k))}
                </span>
              ))}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(94px, 1fr))", gap: 8 }}>
              {list.map((r) => {
                const k = keyFor(r);
                const m = CMETA[k];
                const on = String(r.id) === String(value);
                return (
                  <button key={r.id} type="button" onClick={() => { onChange(r.id); setOpen(false); }}
                    style={{ background: m.bg, border: on ? `2px solid ${m.bd}` : `1px solid ${m.bd}66`, borderRadius: 10, padding: "10px 6px", cursor: "pointer", textAlign: "center" }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: "#063b48" }}>{r.name}</div>
                    <div style={{ fontSize: 10.5, color: m.fg, fontWeight: 600, marginTop: 2 }}>{t(avKey(k))}</div>
                    {r.room_type_name && <div style={{ fontSize: 10, color: "#8a94a3", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.room_type_name}</div>}
                  </button>
                );
              })}
              {list.length === 0 && <div className="muted" style={{ fontSize: 13 }}>—</div>}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
